import { useSelector } from 'react-redux';

import { isLoggedInSelector, isLoggingOutSelector } from 'modules/auth';

export function useIsLoggedInSession(): boolean {
	const isLoggedIn = useSelector(isLoggedInSelector);
	const isLoggingOut = useSelector(isLoggingOutSelector);

	return isLoggedIn && !isLoggingOut;
}
